import { Component, ElementRef, Input, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-static-page',
  standalone: true,
  template: ` <iframe #iframeEl [srcdoc]="htmlContent" width="100%" height="100%" 
      sandbox="allow-forms allow-scripts allow-modals allow-same-origin allow-top-navigation-by-user-activation"
      style="position: absolute;" frameborder="0">
    </iframe>`,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class StaticPageComponent {

  @Input() htmlContent!: string;
  @ViewChild('iframeEl') iframeEl!: ElementRef<HTMLIFrameElement>;
  selectedCountry = {
    "name": '',
    "country_code": '',
    "currency_symbol": '',
    "id": '',
    "flag": ""
  }
  public imageUrl = environment?.imageUrl;

  constructor(private ngZone: NgZone, private authenticationService: AuthenticationService,
    private storageService: StorageService, private commonService: CommonService
  ) { }

  ngOnInit() {
    this.getInitailSetUp();
    window.addEventListener('message', (event) => {
      if (event.data?.type === 'NAVIGATE') {
        const path = event.data.path || '/';
        this.ngZone.run(() => {
          this.authenticationService.setValue();
          const currentUser = this.authenticationService.currentUser();
          if (currentUser) {
            // logged in so return true
            window.location.href = path;
            return false;
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const iframe = this.iframeEl?.nativeElement;
      if (!iframe) {
        console.error('Iframe not found');
        return;
      }

      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDoc) {
        console.error('Iframe document is not accessible');
        return;
      }

      // Handle clicks inside iframe
      iframeDoc.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;

        if (target.tagName === 'A' && target.hasAttribute('href')) {
          event.preventDefault();
          const url = target.getAttribute('href');

          if (url) {
            // Run navigation inside Angular's Zone
            this.ngZone.run(() => {
              window.location.replace(url);
            });
          }
        }
      });
    }, 500); // Ensure iframe content is loaded
  }

  getInitailSetUp() {
    this.commonService.getInit().subscribe((response: Response) => {
      let selectedCountry = JSON.parse(JSON.stringify(response))
      this.selectedCountry = {
        "name": selectedCountry.country_name,
        "country_code": selectedCountry.country_code,
        "currency_symbol": selectedCountry.currency_symbol,
        "id": selectedCountry.country_id,
        "flag": this.imageUrl + "assets/images/flags/" + selectedCountry.country_code + '.svg'
      }
      this.storageService.setLocalStorageItem('selected_country', this.selectedCountry);
    })
  }

}
